// extracted by mini-css-extract-plugin
export default {"root":"FloSlider_root__4csa6","sliderContainer":"FloSlider_sliderContainer__fIndv","valueContainer":"FloSlider_valueContainer__Ce1Aa","valueBox":"FloSlider_valueBox__KDjK2"};